const PRIMARY = '#ffffff';

export default PRIMARY;
